import { useCallback, useEffect, useState } from 'react';
import { IconSun, IconMoon } from '@tabler/icons-react';

import { Button } from '@/components/ui/button';
import { Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip';

function getInitialMode(): 'light' | 'dark' {
  if (typeof window === 'undefined') return 'light';
  const stored = localStorage.getItem('theme');
  if (stored === 'dark' || stored === 'light') return stored;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export default function ThemeModeSwitcher() {
  const [mode, setMode] = useState<'light' | 'dark'>(getInitialMode);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', mode === 'dark');
    localStorage.setItem('theme', mode);
  }, [mode]);

  const handleToggle = useCallback(() => {
    setMode((prev) => (prev === 'light' ? 'dark' : 'light'));
  }, []);

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Button variant="ghost" size="icon" onClick={handleToggle} />
        }
      >
        {mode === 'light' ? <IconMoon size={20} /> : <IconSun size={20} />}
      </TooltipTrigger>
      <TooltipContent>
        {mode === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
      </TooltipContent>
    </Tooltip>
  );
}
